import { InventoryItem } from '../interfaces/inventory-item.interface';
import { InventoryFilterOptions, FilterOption } from '../interfaces/filter-options.interface';

export function extractFilterOptions(items: InventoryItem[]): InventoryFilterOptions {
  const brandsMap = new Map<number, string>();
  const categoriesMap = new Map<number, string>();
  const statusesSet = new Set<string>();
  const locationsSet = new Set<string>();

  for (const item of items) {
    if (item.brand) {
      brandsMap.set(item.brand.id, item.brand.name);
    }

    if (item.mainCategory) {
      categoriesMap.set(item.mainCategory.id, item.mainCategory.name);
    }

    if (item.status) {
      statusesSet.add(item.status);
    }

    if (item.productLocation) {
      locationsSet.add(item.productLocation);
    }
  }

  return {
    brands: mapToFilterOptions(brandsMap),
    categories: mapToFilterOptions(categoriesMap),
    statuses: Array.from(statusesSet).sort((a, b) => a.localeCompare(b)),
    locations: Array.from(locationsSet).sort((a, b) => a.localeCompare(b)),
  };
}

function mapToFilterOptions(map: Map<number, string>): FilterOption[] {
  return Array.from(map.entries()).map(([id, name]) => ({ id, name }));
}
